import { all, call, fork, put, takeLatest } from "redux-saga/effects";
import notify from 'utils/modern_notify';
import {
    BUSCAR_TODOS_DESTINATARIOS,
    BUSCAR_DESTINATARIOS_CIDADE,
    VERIFICAR_DESTINATARIOS_ASSOCIADOS,
    SET_DEST_STATUS,
    BUSCAR_DEST_POR_ESTADO
} from "constants/ActionTypes";
import {
    buscarTodosDestinatariosSucesso,
    buscarDestinatariosCidadeSucesso,
    verificarDestinatariosAssociadosSucesso,
    verificarDestinatariosAssociadosDados,
    setDestStatusSucesso,
    buscarDestPorEstadoSucesso,
    abrirDestSelecionado
} from "actions/Destinatarios";
import { loadRomaneios } from "actions/Romaneios";
import { Creators as ActionsGeral } from "ducks/Geral";
import api from "../api/api";

let mensagemDestinatarios = "";
const buscarTodosDestinatariosRequisicao = async dados =>
    api
        .post("/api/destinatarios/busca/uf/", dados)
        .then(destinatariosData => destinatariosData)
        .catch(error => error);
const buscarDestinatariosCidadeRequisicao = async dados =>
    api
        .post("/api/destinatarios/busca/cidade/", dados)
        .then(destinatariosData => destinatariosData)
        .catch(error => error);
const buscarDestPorEstadoRequisicao = async dados =>
    api
        .post("/api/destinatarios/busca/estado/rota", dados)
        .then(destinatariosData => destinatariosData)
        .catch(error => error);

const verificarDadosDestinatariosAssociadosRequisicao = async dados =>
    api
        .post(`/api/destinatarios/busca/semrota/`, dados)
        .then(destinatariosData => destinatariosData)
        .catch(error => error);

const setDestStatusDadosRequisicao = async destinatarios =>
    api.put("/api/destinatarios/atualizarstatus", destinatarios);

function* buscarTodosDestinatarios({ payload }) {
    const { cnpjEmpresa, cnpjRemetente, filtrar } = payload;
    const dados = {
        cnpjEmpresa: Array.isArray(cnpjEmpresa) ? cnpjEmpresa : [cnpjEmpresa],
        cnpj_distribuidora: cnpjRemetente,
        filtrar
    };
    let destinatariosData = [];
    let mensagemDestinatarios = "";
    try {
        const response = yield call(buscarTodosDestinatariosRequisicao, dados);
        if (response.ok) {
            if (response.data.resultado) {
                destinatariosData = response.data.valor;
                yield put(buscarTodosDestinatariosSucesso(destinatariosData));
            }
        } else {
            if (Object.prototype.hasOwnProperty.call(response.data, "erro")) {
                switch (response.data.erro) {
                    default:
                        mensagemDestinatarios = `Ocorreu um erro ${response.data.erro}`;
                        break;
                }
            } else {
                mensagemDestinatarios =
                    "Ocorreu um erro interno.Tente novamente";
            }
            notify(mensagemDestinatarios)
        }
    } catch (error) {
        notify(`Erro buscar destinatários: ${error}`)
    }
}

function* buscarTodosDestinatariosCidade({ payload }) {
    const { cidade, cnpjEmpresa, cnpjRemetente, filtrar } = payload;
    const dados = {
        cnpjEmpresa: Array.isArray(cnpjEmpresa) ? cnpjEmpresa : [cnpjEmpresa],
        cnpj_distribuidora: cnpjRemetente,
        cidade,
        filtrar
    };
    const destinatariosData = [];
    let mensagemDestinatarios = "";
    try {
        const response = yield call(buscarDestinatariosCidadeRequisicao, dados);
        if (response.ok) {
            if (response.data.resultado) {
                response.data.valor.forEach(item => {
                    destinatariosData.push({
                        destNome: item.nome_dest ? item.nome_dest : "",
                        destEnd: item.end_dest ? item.end_dest : "",
                        destBairro: item.bairro_dest ? item.bairro_dest : "",
                        destCidade: item.cidade_dest ? item.cidade_dest : "",
                        destUf: item.uf_dest ? item.uf_dest : "",
                        destRemetente: item.remetente ? item.remetente : "",
                        distribuidoras: item.distribuidoras
                            ? item.distribuidoras
                            : [],
                        cnpjitem: item.cnpj_item ? item.cnpj_item : "",
                        numeroitem: item.numero_item ? item.numero_item : "",
                        status:
                            typeof item.status == "boolean"
                                ? item.status
                                : true,
                        _id: item._id
                    });
                });

                yield put(buscarDestinatariosCidadeSucesso(destinatariosData));
            }
        } else {
            if (Object.prototype.hasOwnProperty.call(response.data, "erro")) {
                switch (response.data.erro) {
                    default:
                        mensagemDestinatarios = `Ocorreu um erro${response.data.erro}`;
                        break;
                }
            } else {
                mensagemDestinatarios =
                    "Ocorreu um erro interno.Tente novamente";
            }
            notify(mensagemDestinatarios)
        }
    } catch (error) {
        notify(`Erro buscar cidades: ${error}`)
    }
}
function* buscarDestPorEstado({ payload }) {
    const { estado, cnpjEmpresa, cnpjRemetente, filtrar } = payload;
    let destinatariosData = {};
    let mensagemDestinatarios = "";
    const dados = {
        cnpjEmpresa: Array.isArray(cnpjEmpresa) ? cnpjEmpresa : [cnpjEmpresa],
        cnpj_distribuidora: cnpjRemetente,
        uf: estado,
        filtrar
    };
    try {
        const response = yield call(buscarDestPorEstadoRequisicao, dados);
        if (response.ok) {
            if (response.data) {
                destinatariosData = response.data;
                yield put(buscarDestPorEstadoSucesso(destinatariosData));
                yield put(abrirDestSelecionado());
            }
        } else {
            if (Object.prototype.hasOwnProperty.call(response.data, "erro")) {
                switch (response.data.erro) {
                    default:
                        mensagemDestinatarios = `Ocorreu um erro${response.data.erro}`;
                        break;
                }
            } else {
                mensagemDestinatarios =
                    "Ocorreu um erro interno.Tente novamente";
            }
            notify(mensagemDestinatarios)
        }
    } catch (error) {
        notify(`Erro buscar por estado: ${error}`)
    }
}

function* setDestStatusDados({ payload }) {
    const { status, _id } = payload;
    mensagemDestinatarios = "";
    const destinatarios = [
        {
            _id,
            status
        }
    ];
    try {
        const response = yield call(
            setDestStatusDadosRequisicao,
            destinatarios
        );
        if (response.ok) {
            if (response.data.resultado) {
                yield put(
                    setDestStatusSucesso({
                        status,
                        _id
                    })
                );
            } else {
                mensagemDestinatarios =
                    "Não foi possível atualizar o destinatário";
                notify(mensagemDestinatarios)
            }
        } else {
            mensagemDestinatarios = "Não foi possível atualizar o destinatário";
            notify(mensagemDestinatarios)
        }
    } catch (error) {
        notify(`Erro mudar status destinatário: ${error}`)
    }
}

function* verificarDadosDestinatariosAssociados({ payload }) {
    const { cnpjEmpresa } = payload;
    let destinatariosData = [];
    mensagemDestinatarios = "";
    const dados = {
        cnpjEmpresa: Array.isArray(cnpjEmpresa) ? cnpjEmpresa : [cnpjEmpresa]
    };
    try {
        const response = yield call(
            verificarDadosDestinatariosAssociadosRequisicao,
            dados
        );
        if (response.ok) {
            if (response.data.resultado) {
                if (response.data.valor.length === 0) {
                    yield put(
                        verificarDestinatariosAssociadosSucesso(
                            destinatariosData
                        )
                    );
                    yield put(loadRomaneios(false));
                } else {
                    destinatariosData = response.data.valor.map(dest => ({
                        destNome: dest.nome_dest ? dest.nome_dest : "",
                        destEnd: dest.end_dest ? dest.end_dest : "",
                        destBairro: dest.bairro_dest ? dest.bairro_dest : "",
                        destCidade: dest.cidade_dest ? dest.cidade_dest : "",
                        destUf: dest.uf_dest ? dest.uf_dest : "",
                        destRemetente: dest.remetente ? dest.remetente : "",
                        distribuidoras: dest.distribuidoras
                            ? dest.distribuidoras
                            : [],
                        cnpjDest: dest.cnpj_dest ? dest.cnpj_dest : "",
                        numeroDest: dest.numero_dest ? dest.numero_dest : "",
                        codCidade: dest.cod_cidade ? dest.cod_cidade : "",
                        status:
                            typeof dest.status == "boolean"
                                ? dest.status
                                : true,
                        _id: dest._id
                    }));
                    yield put(
                        verificarDestinatariosAssociadosDados(destinatariosData)
                    );
                }
            }
        } else {
            notify(mensagemDestinatarios)
            yield put(loadRomaneios(false));
        }
    } catch (error) {
        notify(`Erro verificar destinatários associados: ${error}`)
        yield put(loadRomaneios(false));
    }
}

export function* buscarDadosTodosDestinatarios() {
    yield takeLatest(BUSCAR_TODOS_DESTINATARIOS, buscarTodosDestinatarios);
}
export function* buscarDadosTodosDestinatariosCidade() {
    yield takeLatest(
        BUSCAR_DESTINATARIOS_CIDADE,
        buscarTodosDestinatariosCidade
    );
}
export function* buscarDadosDestPorEstado() {
    yield takeLatest(BUSCAR_DEST_POR_ESTADO, buscarDestPorEstado);
}
export function* verificarDadosDestintariosAssociados() {
    yield takeLatest(
        VERIFICAR_DESTINATARIOS_ASSOCIADOS,
        verificarDadosDestinatariosAssociados
    );
}
export function* setDestinatarioStatus() {
    yield takeLatest(SET_DEST_STATUS, setDestStatusDados);
}
export default function* rootSaga() {
    yield all([
        fork(buscarDadosTodosDestinatarios),
        fork(buscarDadosTodosDestinatariosCidade),
        fork(verificarDadosDestintariosAssociados),
        fork(setDestinatarioStatus),
        fork(buscarDadosDestPorEstado)
    ]);
}
